export const DELETE_PLC_SAFETY_TRIGGER = 'DELETE_PLC_SAFETY_TRIGGER';
export const DELETE_PLC_SAFETY_TRIGGER_SUCCESSFUL = 'DELETE_PLC_SAFETY_TRIGGER_SUCCESSFUL';
export const DELETE_PLC_SAFETY_TRIGGER_FAILED = 'DELETE_PLC_SAFETY_TRIGGER_FAILED';
